<template>
	<div>
		<div>
			<p class="title">数据资源入表</p>
			<div class="flowServer">
				<ul>
					<li>
						<img src="../../../../assets/img/service/dataAssetsTabulated/entryService.png" alt="数据资源入表服务">
						<div>
							<p>数据资源入表服务</p>
							<p>数据资源入表咨询及解决方案服务</p>
						</div>
						<span>01</span>
					</li>
					<li>
						<img src="../../../../assets/img/service/dataAssetsTabulated/dataAssetValuation.png" alt="数据资产估值">
						<div>
							<p>数据资产估值</p>
							<p>数据资产估值可以为企业融资提供更公允的价值参考依据</p>
						</div>
						<span>02</span>
					</li>
					<li>
						<img src="../../../../assets/img/service/dataAssetsTabulated/dataAssetRealization.png" alt="数据资产变现">
						<div>
							<p>数据资产变现</p>
							<p>帮助企业将数据资产转化为经济收益</p>
						</div>
						<span>03</span>
					</li>
					<li>
						<img src="../../../../assets/img/service/dataAssetsTabulated/dataEvaluationReport.png" alt="数据价值评价报告">
						<div>
							<p>数据价值评价报告</p>
							<p>多个维度进行分析数据资产状况和价值</p>
						</div>
						<span>04</span>
					</li>
				</ul>
			</div>
		</div>
		<div>
			<p class="title titleTop">具体实施方案</p>
			<table class="embodiment" border="0" style="border-collapse: collapse;">
				<thead>
					<th style="width: 11%;">工作项目</th>
					<th style="width: 16%;">具体内容</th>
					<th style="width: 36%;">工作要点</th>
					<th style="width: 17%;">甲方职责</th>
					<th style="width: 20%;">工作成果输出</th>
				</thead>
				<tbody>
					<tr>
						<td rowspan="4" class="center">项目统筹（5-10个工作日）</td>
						<td rowspan="2">前期沟通</td>
						<td>1、与管理层及主要人员前期意向沟通</td>
						<td rowspan="2">参与前期沟通，协调协议签订</td>
						<td>1、数据资产入表培训1次</td>
					</tr>
					<tr>
						<td>2、协议签订</td>
						<td>2、服务协议</td>
					</tr>
					<tr>
						<td rowspan="2">数据资源入表专项尽职调查</td>
						<td>1、提供数据资源入表专项尽职调查清单，进行尽职调查</td>
						<td>1、内部沟通协调，提供尽职调查资料</td>
						<td rowspan="2">尽调资料清单</td>
					</tr>
					<tr>
						<td>2、提供高管及相关人员访谈问题清单，进行访谈 </td>
						<td>2、协调高管及相关人员进行访谈</td>
					</tr>
					<tr class="even">
						<td rowspan="4">方案设计（5-10个工作日）</td>
						<td>数据资源清单整理</td>
						<td>提供数据资源盘点清单，共同讨论确定数据资源分类方法，协助公司进行数据资源整理</td>
						<td>协助落实数据资源整理工作</td>
						<td>数据资源信息表</td>
					</tr>
					<tr class="even">
						<td rowspan="2">数据产品规划及应用场景研讨</td>
						<td>1、依据数据资源分类结果进行数据产品规划设计</td>
						<td>1、组织管理层及相关业务团队与我司共同研究设计数据产品</td>
						<td rowspan="2">《数据产品规划方案》</td>
					</tr>
					<tr class="even">
						<td>2、与专项小组研究数据产品未来的应用场景</td>
						<td>2、协助我司调研数据产品应用场景的反馈，提出改进建议</td>
					</tr>
					<tr class="even">
						<td>数据资源入表方案设计</td>
						<td>根据尽职调查结果和数据产品规划方案，提供数据资源入表路径</td>
						<td>组织财务人员与我司进行讨论，确定最终入表路径</td>
						<td>《数据资源入表方案》</td>
					</tr>
					<tr>
						<td rowspan="6">方案实施（10-20个工作日）</td>
						<td rowspan="4">数据资源账务处理及入表</td>
						<td>1、依据财政部《暂行规定》，提出数据资源相应的科目设置、账务处理、支撑文件及减值测试等具体账务处理方法</td>
						<td rowspan="2">1、指定专人配合我司进行账务处理相关规则等讨论并确认账务处理方法，完成内部相</td>
						<td>1、数据资源账务体系</td>
					</tr>
					<tr>
						<td>2、与财务共同完成相关财务制度和会计政策的调整</td>
						<td rowspan="2">2、财务制度及会计政策调整方案</td>
					</tr>
					<tr>
						<td>3、数据资产入表支撑文件规划</td>
						<td rowspan="2">2、与我司团队共同完成财务制度和会计政策的调整</td>
					</tr>
					<tr>
						<td>4、指导培训财务人员理解并掌握账务处理方法 </td>
						<td>3、研发项目流程模板</td>
					</tr>
					<tr>
						<td>辅导数据治理制度制定</td>
						<td colspan="2">专项小组成员共同讨论确定并出台数据治理试行制度或规定（根据公司需求确定）</td>
						<td>数据资产管理制度</td>
					</tr>
					<tr>
						<td>数据资产估值</td>
						<td>专业估值人员现场调查完成后，采用心流慧·DV产品，以指定的某一估值基准日进行数据资产估值</td>
						<td>与我司团队共同完成数据资产估值并确认</td>
						<td>心流慧·DV估值报告一份</td>
					</tr>
					<tr class="even">
						<td>数据确权</td>
						<td>数据资产品确权登记</td>
						<td>协助指导对入表对数据资产产品在数据交易所上进行确权登记</td>
						<td>指定专人配合我司工作，并提供确权登记相关材料</td>
						<td>数据资源登记表</td>
					</tr>


				</tbody>
			</table>
			<p>备注：具体时间安排及工作内容需以专项小组讨论确定后的工作计划和时间安排为准</p>
		</div>
		<div>
			<p class="title titleTop">为什么选择我们</p>
			<ul class="team">
				<li>
					<img src="../../../../assets/img/service/dataAssetsTabulated/team1.png" alt="专业咨询">
					<p>专业咨询</p>
					<p>帮助企业有效地规划和管理数据资产，提开数据的利用价值，支持业务决策和创新。</p>
				</li>
				<li>
					<img src="../../../../assets/img/service/dataAssetsTabulated/team2.png" alt="资深会计">
					<p>资深会计</p>
					<p>确保数据资产的会计处理符合会计准则的要求，并真实反映企业在数据资产方面的投资和价值。</p>
				</li>
				<li>
					<img src="../../../../assets/img/service/dataAssetsTabulated/team3.png" alt="专业估值师">
					<p>专业估值师</p>
					<p>综合运用多种方法和技术，结合具体情况进行细致分析，以确保估值结果的准确性和合理性。</p>
				</li>
				<li>
					<img src="../../../../assets/img/service/dataAssetsTabulated/team4.png" alt="资深审计">
					<p>资深审计</p>
					<p>从审计角度出发，遵循会计准则和审计标准，确保数据资产的入表和估值合理、准确和可验证。</p>
				</li>
				<li>
					<img src="../../../../assets/img/service/dataAssetsTabulated/team5.png" alt="专业律师">
					<p>专业律师</p>
					<p>确保数据资产的获取、使用和存储符合相关法律法规;确保各项操作符合会计准则和法律法规的要求。</p>
				</li>
			</ul>
		</div>
		<div>
			<p class="title titleTop">经典案例</p>
			<div class="case">
				<div style="width:695px;top: 36px;left: 20%;position: relative;overflow: hidden;border-radius: 10px;">
					<div class="swiper">
						<div class="swiper-wrapper" id="logobox" style="border-radius: 10px;">
							<div class="swiper-slide">
								<p class="projectTitle">某能源行业系统服务提供商获银行授信</p>
								<p class="introductionTitle">项目简介</p>
								<div class="projectIntroduction">
									<p>
										<span>项目名称：</span>
										<span>某能源行业系统服务提供商</span>
									</p>
									<p>
										<span>服务内容：</span>
										<span>数据资源入表、数据资产估值</span>
									</p>
								</div>
								<p class="introductionTitle">案例亮点</p>
								<div class="projectHighlights">
									<p>1.建立数据资产管理部门及数据资产管理制度；</p>
									<p>2.建立数据资产相关业务的财务核算管理流程、账务处理方法、支撑文件规范及内控制度；</p>
									<p>3.采用心流慧·DV为公司提供数据资产估值服务，并成功获某商业银行1000万授信。</p>
								</div>
							</div>
							<div class="swiper-slide">
								<p class="projectTitle">江苏某市某城投公司获银行授信</p>
								<p class="introductionTitle">项目简介</p>
								<div class="projectIntroduction">
									<p>
										<span>项目名称：</span>
										<span>连云港某城投公司</span>
									</p>
									<p>
										<span>服务内容：</span>
										<span>数据资源入表、数据资产估值</span>
									</p>
								</div>
								<p class="introductionTitle">案例亮点</p>
								<div class="projectHighlights">
									<p>1.根据前期调研情况进行政府部门可用资源确定及方案设计；</p>
									<p>2.根据专项尽调结果结合国家规定和监管政策数据初步数据资源入表财务处理方案；</p>
									<p>3.采用心流慧·DV为公司提供数据资产估值服务，并成功获某商业银行5000万授信。</p>
								</div>
							</div>
							<div class="swiper-slide">
								<p class="projectTitle">智慧+系统集成商</p>
								<p class="introductionTitle">项目简介</p>
								<div class="projectIntroduction">
									<p>
										<span>项目名称：</span>
										<span>某智慧+系统集成商(智慧城市、智慧水务、智慧交通等)</span>
									</p>
									<p>
										<span>服务内容：</span>
										<span>数据资源入表</span>
									</p>
								</div>
								<p class="introductionTitle">案例亮点</p>
								<div class="projectHighlights">
									<p>1.根据公司现状及数据资产相关政策，发现和分析内部、外部的各种数据，识别公司现有数据资源；</p>
									<p>2.结合公司组织架构及管理制度，围绕数据资源特性及入表规范，建立数据资产管理部门及数据资产管理制度。</p>
								</div>
							</div>
							<div class="swiper-slide">
								<p class="projectTitle">工业互联网安全</p>
								<p class="introductionTitle">项目简介</p>
								<div class="projectIntroduction">
									<p>
										<span>项目名称：</span>
										<span>某工业互联网小巨人</span>
									</p>
									<p>
										<span>服务内容：</span>
										<span>数据资源入表、数据资产估值</span>
									</p>
								</div>
								<p class="introductionTitle">案例亮点</p>
								<div class="projectHighlights">
									<p>1.确定拥有数据资产的类别，科目归属及明细科目核算级次和名称定义等；</p>
									<p>2.采集治理层、管理层、执行层面对试点数据资源入表财务处理方案的意见和建议；</p>
									<p>3.联系律所对相关数据来源及用途合法合规性进行审查。</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="btn">
					<p id="prev" @click="prev">
						<i class="iconfont icon-jiantouleft"></i>
					</p>
					<p id="next" @click="next">
						<i class="iconfont icon-jiantouright"></i>
					</p>
				</div>
			</div>



		</div>

	</div>
</template>

<script>
	import Swiper, {
		Pagination,
		Navigation,
		Autoplay
	} from 'swiper'


	// import 'swiper/swiper.min.css'
	import 'swiper/swiper-bundle.css'; // 或 swiper/css/swiper.css 根据需要选择
	Swiper.use([Pagination, Navigation, Autoplay])

	export default {
		data() {
			return {


			}
		},
		mounted() {
			this.$nextTick(() => {
				// this.initSwiper();

			})

		},
		methods: {
			initSwiper() {
				var mySwiper = new Swiper('.swiper', {
					slidesPerView: 1.5,
					centeredSlides: true,
					spaceBetween: 25,
					initialSlide: 1,
					loop: true,
					navigation: {
						nextEl: '#next',
						prevEl: '#prev',
					},
				})


			},
			slideTo(container, direction, duration = 500) {
				var start = performance.now();
				var distance = 400; // 假设每个 slide 的宽度是 580px
				var progress = 0;

				function step(timestamp) {
					progress = (timestamp - start) / duration;
					if (progress > 1) progress = 1;

					var translateValue = direction === 'next' ? -distance * progress : distance * progress;
					container.style.transform = `translateX(${translateValue}px)`;

					if (progress < 1) {
						requestAnimationFrame(step);
					} else {
						console.log('动画完成后的处理，比如更新')
						// 动画完成后的处理，比如更新 DOM 结构
						if (direction === 'next') {
							var $first = $('#logobox .swiper-slide:first');
							$first.appendTo('#logobox'); // 将第一个 slide 移动到末尾
							container.style.transform = 'translateX(0)';

						} else if (direction === 'prev') {
							$('#logobox').find('.swiper-slide:last').remove();
							container.style.transform = 'translateX(0)';
						}

					}

				}

				requestAnimationFrame(step);
			},
			next() {
				var $container = $('#logobox')[0]; // 获取 DOM 元素
				this.slideTo($container, 'next');
			},
			prev() {
				var $container = $('#logobox')[0]; // 获取 DOM 元素

				setTimeout(function() {
					var $lastItem = $('#logobox').find('.swiper-slide:last'); //获取最后一个元素
					var copy = $lastItem.clone(); // 复制元素
					// 将复制的元素添加到最前面
					$('#logobox').prepend(copy);
				}, 500)

				this.slideTo($container, 'prev');
			}



		}

	}
</script>

<style scoped lang="less">
	.flowServer ul {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.flowServer ul li {
		width: 49%;
		height: 176px;
		background: url(../../../../assets/img/service/dataAssetsTabulated/flowServer_bg.jpg) center center no-repeat;
		background-size: cover;
		padding: 17px 20px;
		box-shadow: 2px 2px 13px 0px rgba(32, 76, 151, 0.23);
		border: 2px solid #fff;
		box-sizing: border-box;
		position: relative;
		display: flex;
	}

	.flowServer ul li:nth-child(-n+2) {
		margin-bottom: 20px;
	}

	.flowServer ul li img {
		width: 130px;
		height: 97px;
		margin-right: 30px;
		position: relative;
		top: 24px;
	}

	.flowServer ul li>div p:first-child {
		font-size: 20px;
		font-weight: bold;
		color: #282828;
		margin: 13px 0 12px;
	}

	.flowServer ul li>div p:last-child {
		font-size: 16px;
		line-height: 24px;
		color: #282828;
	}

	.flowServer ul li>span {
		width: 53px;
		height: 45px;
		line-height: 50px;
		font-size: 24px;
		font-weight: bold;
		color: var(--mainColor);
		text-align: center;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	// 具体实施方案
	.embodiment+p {
		font-size: 16px;
		color: #282828;
		margin-top: 11px;
		margin-left: 26px;
	}

	.embodiment {
		width: 100%;
	}

	.embodiment thead th {
		height: 50px;
		background: var(--mainColor);
		font-size: 16px;
		font-weight: bold;
		color: #fff;
		text-align: center;
		border-right: 1px solid #F7FBFF;
	}

	.embodiment tbody tr.even td {
		background: #f4f4f4;
	}

	.embodiment tbody td {
		line-height: 20px;
		font-size: 14px;
		color: #282828;
		background: #ECECEC;
		border-left: 1px solid #F7FBFF;
		border-bottom: 1px solid #F7FBFF;
		padding: 10px 17px;
		text-align: justify;
	}

	.embodiment tbody td.center {
		text-align: center;
		padding: 12px 0;
	}

	// 为什么选择我们

	.team {
		width: 100%;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}

	.team li {
		position: relative;
	}

	.team li:not(:last-child)::after {
		content: "";
		display: block;
		width: 30px;
		height: 30px;
		background: url(../../../../assets/img/service/dataAssetsTabulated/connector.png) center center no-repeat;
		background-size: cover;
		position: absolute;
		top: 56px;
		right: -50px;
	}

	.team li img {
		width: 112px;
		display: block;
		margin: 9px auto 6px;
	}

	.team li p {
		width: 111px;
	}

	.team li p:nth-of-type(1) {
		font-size: 20px;
		font-weight: bold;
		color: #282828;
		text-align: center;
		margin-bottom: 8px;
	}

	.team li p:nth-of-type(2) {
		font-size: 14px;
		color: #282828;
		text-align: justify;
	}

	// 经典案例
	.case {
		width: 100%;
		height: 454px;
		background: url(../../../../assets/img/service/dataAssetsTabulated/case.jpg) center center no-repeat;
		background-size: cover;
		margin-top: 50px;
		position: relative;
		overflow: hidden;
	}

	.caseContent {
		width: 70%;
		height: 308px;
		position: absolute;
		top: 36px;
		right: 0;
	}

	// .case .swiper-slide {
	// 	height: 255px;
	// 	background: #f4f4f4;
	// 	padding: 23px 26px 26px;
	// 	box-sizing: content-box;
	// 	border-radius: 10px;
	// 	-webkit-border-radius: 10px;
	// 	-moz-border-radius: 10px;
	// 	-ms-border-radius: 10px;
	// 	-o-border-radius: 10px;
	// }

	.case .swiper-slide {
		width: 377px !important;
		height: 268px;
		background: #FFFFFF;
		padding: 21px 26px 26px;
		margin-right: 20px;
		box-sizing: content-box;
		border-radius: 10px;
		-webkit-border-radius: 10px;
		-moz-border-radius: 10px;
		-ms-border-radius: 10px;
		-o-border-radius: 10px;
		transition: transform 0.5s ease;
		-webkit-transition: transform 0.5s ease;
		-moz-transition: transform 0.5s ease;
		-ms-transition: transform 0.5s ease;
		-o-transition: transform 0.5s ease;
	}

	.case .btn {
		display: flex;
		position: absolute;
		left: 50%;
		bottom: 40px;
		transform: translateX(-60%);
		-webkit-transform: translateX(-60%);
		-moz-transform: translateX(-60%);
		-ms-transform: translateX(-60%);
		-o-transform: translateX(-60%);
	}

	.case .btn p {
		width: 40px;
		height: 40px;
		cursor: pointer;
		background: url(../../../../assets/img/service/dataAssetsTabulated/btn.png);
		margin-right: 20px;
		text-align: center;
		line-height: 40px;
	}

	.case .btn #prev i,
	.case .btn #next i {
		font-size: 20px;
	}

	.case .btn #prev:hover i,
	.case .btn #next:hover i {
		color: var(--mainColor);
	}

	.projectTitle {
		font-size: 20px;
		color: #282828;
		font-weight: bold;
	}

	.introductionTitle {
		font-size: 18px;
		color: #282828;
		font-weight: bold;
		margin-top: 10px;
		margin-bottom: 5px;
	}

	.projectIntroduction p span,
	.projectHighlights p {
		font-size: 14px;
	}

	.projectIntroduction p span:first-child {
		font-weight: bold;
	}

	.projectHighlights p:not(:last-child) {
		margin-bottom: 5px;
	}
</style>